/// <amd-module name="VSS/Redux/Modules/QueuedActions/QueuedActionsModule" />
import { queuedActionsRootSaga } from "./QueuedActionsSaga";

export const QueuedActionsModule = {
    id: "queued-actions",
    sagas: [queuedActionsRootSaga]
}
